const origin = window.location.origin;
const pathReg = /^https:\/\/(haohuo|ffh)\.(?:jinritemai|snssdk)\.com$/i;
let pageOrigin = 'https://haohuo.jinritemai.com';

if (pathReg.test(origin)) {
    pageOrigin = origin;
}
export const PAGE_ORIGIN = pageOrigin;

export const API_ORIGIN = 'https://haohuo.snssdk.com';
export const API_EC = 'https://ec.snssdk.com';
export const API_KEN = 'https://ken.snssdk.com';
export const API_LIANMENG = 'https://lianmengapi.snssdk.com';
export const API_USER = 'https://ecomuser.snssdk.com';
